import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    '& .cms-table-scroll': {
      width: '100%',
      maxWidth: '100%',
      margin: '20px 0',
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch',
      border: '1px solid #E1E5EA',
      borderRadius: '12px',
      boxShadow: '0 4px 14px rgba(23, 43, 58, 0.06)',
    },
    '& table': {
      width: '100%',
      minWidth: { xs: '560px', md: '100%' },
      borderCollapse: 'collapse',
      borderSpacing: 0,
      backgroundColor: 'common.white',
      color: 'custom.grey',
      fontSize: { xs: '13px', md: '15px' },
      lineHeight: 1.5,
    },
    '& th, & td': {
      padding: { xs: '11px 12px', md: '13px 16px' },
      borderRight: '1px solid #E1E5EA',
      borderBottom: '1px solid #E1E5EA',
      textAlign: 'left',
      verticalAlign: 'top',
      overflowWrap: 'anywhere',
    },
    '& th:last-child, & td:last-child': {
      borderRight: 0,
    },
    '& tr:last-child td': {
      borderBottom: 0,
    },
    '& th': {
      backgroundColor: 'primary.main',
      color: 'common.white',
      fontWeight: 700,
      letterSpacing: '0.01em',
    },
    '& tbody tr:nth-of-type(even)': {
      backgroundColor: '#FAF5F7',
    },
    '& tbody tr:hover': {
      backgroundColor: '#F5E9EE',
    },
    '& table p': {
      margin: '0 !important',
    },
    '& caption': {
      padding: '0 0 10px',
      color: 'custom.grey',
      fontWeight: 700,
      textAlign: 'left',
    },
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
